import React, { useEffect, useState } from 'react'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Box, Button, Grid, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function AlternativeInvestmentCard({ result = [] }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [viewData, setViewData] = useState({})
  useEffect(() => {
    if (result.length > 0) {
      setViewData(result[4])
    }
  }, [result])
  const handelbutton = (type) => {
    setViewData(result.find((r) => r.type === type))
  }
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500, alignItems: '' }}>
          <Box sx={{ height: 25, width: 25, mr: 1, overflow: 'hidden' }}>
            <img src="/images/alternatif.png" alt="" style={{ marginTop: '-8px' }} />
          </Box>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.markeet.alternative.title')}</Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ color: 'gray' }}>{viewData?.title}</Box>
        </Box>
      </Box>
      <Box
        mt={1}
        height={'100%'}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {viewData?.type === 'vins_alternatifs' && (
          <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <Box display={'flex'} justifyContent={'space-between'} gap={2}>
              {viewData?.data.map((item, index) => (
                <Box key={index} sx={{ width: '50%', display: 'flex' }}>
                  <Box sx={{ width: '80%', mr: 1 }}>
                    <img alt="" style={{ width: '100%' }} src={item.image} />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <Box>{item.name}</Box>
                    <Box component={'span'} color={item.variation_1_an >= 0 ? 'green' : 'red'}>
                      {item.variation_1_an}%
                    </Box>
                    <Box>{item.price} €</Box>
                  </Box>
                </Box>
              ))}
            </Box>
            <Box mt={2}>
              {/* LAP-733 (GE022) */}
              <Box>{t('investments.markeet.alternative.index')}</Box>
              <Box mt={1} px={1}>
                {viewData?.indice.map((item, index) => (
                  <Box key={index} display={'flex'}>
                    <Box>{item.name}</Box>
                    <Box sx={{ color: item.variation_1_an >= 0 ? 'green' : 'red', ml: 'auto' }}>
                      {item.variation_1_an}%
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        )}
        {viewData?.type === 'montre_alternatifs' && (
          <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <Grid container spacing={2}>
              {viewData?.data.map((item, index) => (
                <Grid key={index} item sm={6}>
                  <Box sx={{ display: 'flex' }} mt={3}>
                    <Box sx={{ width: '80%', mr: 1 }}>
                      <img alt="" style={{ width: '100%' }} src={item.image} />
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                      }}
                    >
                      <Box>{item.modele}</Box>
                      <Box>{item.marque}</Box>
                      <Box component={'span'} color={item.variation_1_an >= 0 ? 'green' : 'red'}>
                        {item.variation_1_an}%
                      </Box>
                      <Box>{item.price} €</Box>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
        {viewData?.type === 'crypto_asset' && (
          <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <Grid container spacing={2}>
              {viewData?.data.map((item, index) => (
                <Grid key={index} item sm={6}>
                  <Box sx={{ display: 'flex' }}>
                    <Box
                      sx={{
                        width: '80%',
                        mr: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        height: 72,
                      }}
                    >
                      <img alt="" style={{ height: '100%' }} src={item.image} />
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                      }}
                    >
                      <Box>{item.symbol}</Box>
                      <Box>{item.name}</Box>
                      <Box>
                        {item.price}

                        <Box
                          component={'span'}
                          color={item.changePercentage >= 0 ? 'green' : 'red'}
                        >
                          {item.changePercentage}%
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
        {viewData?.type === 'art_alternatifs' && (
          <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <Grid container spacing={2}>
              {viewData?.data.map((item, index) => (
                <Grid key={index} item sm={6}>
                  <Box sx={{ display: 'flex' }} mt={3}>
                    <Box sx={{ width: '80%', mr: 1 }}>
                      <img alt="" style={{ width: '100%' }} src={item.image} />
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                      }}
                    >
                      <Box>{item.modele}</Box>
                      <Box>{item.artiste}</Box>
                      <Box color={'gray'}>{item.subtype}</Box>
                      <Box fontWeight={700}>{item.price} €</Box>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
        {viewData?.type === 'voiture_alternatifs' && (
          <Box
            sx={{ flexGrow: 1, overflow: 'hidden' }}
            display={'flex'}
            flexDirection={'column'}
            gap={2}
          >
            {viewData?.data.map((item, index) => (
              <Box key={index} display={'flex'}>
                <Box
                  sx={{
                    width: 150,
                    display: 'flex',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    mr: '8px',
                  }}
                >
                  <img src={item.image} alt="" />
                </Box>
                <Box>
                  <Box>
                    {item.marque} {item.modele}
                  </Box>
                  <Box>{item.annee}</Box>
                  <Box>{item.price} €</Box>
                </Box>
              </Box>
            ))}
          </Box>
        )}
        {viewData?.button && (
          <Box sx={{}}>
            <Stack spacing={2} direction="row" sx={{ justifyContent: 'center' }}>
              <Button
                variant="text"
                sx={{ color: 'gray', paddingY: 0 }}
                endIcon={
                  <ArrowDropUpIcon
                    sx={{ fontSize: '2.5rem !important', transform: 'rotate(270deg)' }}
                  />
                }
                onClick={() => handelbutton(viewData?.button[0].type)}
              >
                {viewData?.button[0].name}
              </Button>
              <Button
                variant="text"
                sx={{ color: 'gray', paddingY: 0 }}
                startIcon={
                  <ArrowDropDownIcon
                    sx={{ fontSize: '2.5rem !important', transform: 'rotate(270deg)' }}
                  />
                }
                onClick={() => handelbutton(viewData?.button[1].type)}
              >
                {viewData?.button[1].name}
              </Button>
            </Stack>
          </Box>
        )}
      </Box>
    </Box>
  )
}
